import React from 'react';
import styled, { css } from 'styled-components';
import { globalTheme, useMixin } from '@clds/component-theme';
import { ArrowDropDown, ArrowDropUp } from '@clds/icon';
import { numberFieldTheme } from '../theme.js';
const DIRECTION = {
    UP: 'up',
    DOWN: 'down',
};
export const ButtonsContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin: 0 ${globalTheme.spacing.xs};
`;
const TrailingContainer = styled.div `
  display: flex;
  position: absolute;
  right: 0;
  pointer-events: none;
  background: ${numberFieldTheme.buttons.background};
`;
const iconAsButtonCommon = css `
  box-sizing: content-box;
  padding: 0 ${numberFieldTheme.buttons.padding};
  &:focus {
    outline: none;
  }
`;
export const ArrowUpButton = styled(ArrowDropUp).attrs({
    tabIndex: 0,
}) `
  ${iconAsButtonCommon}
  ${({ buttonPaddingSize }) => `padding-top: ${buttonPaddingSize};`}
`;
export const ArrowDownButton = styled(ArrowDropDown).attrs({
    tabIndex: 0,
}) `
  ${iconAsButtonCommon}
  ${({ buttonPaddingSize }) => `padding-bottom: ${buttonPaddingSize};`}
`;
const NumericDecorator = ({ isDisabled = false, }) => {
    const buttonPaddingSize = useMixin(numberFieldTheme.buttons.padding);
    return (React.createElement(React.Fragment, null,
        React.createElement(TrailingContainer, null,
            React.createElement(ButtonsContainer, null,
                React.createElement(ArrowUpButton, { size: "xs", color: isDisabled ? 'secondaryAlt' : 'contrastLow', "aria-disabled": isDisabled ? 'true' : 'false', buttonPaddingSize: buttonPaddingSize, "data-direction": DIRECTION.UP, "data-test-specifier": "arrow-up" }),
                React.createElement(ArrowDownButton, { size: "xs", color: isDisabled ? 'secondaryAlt' : 'contrastLow', "aria-disabled": isDisabled ? 'true' : 'false', buttonPaddingSize: buttonPaddingSize, "data-direction": DIRECTION.DOWN, "data-test-specifier": "arrow-down" })))));
};
// eslint-disable-next-line import/no-default-export
export default NumericDecorator;
//# sourceMappingURL=NumericDecorator.js.map